import {
  ChangeDetectorRef,
  ContentChildren,
  Directive,
  Input,
  Injector,
  QueryList,
} from '@angular/core';
import { TRACK_FN } from '../../utils';
import { TrackUtil } from '../../track-util';
import { TrackEvent } from '../../track-handlers';
import { TrackImpressionProductDirective } from './track-impression-product.directive';

@Directive({
  selector: '[cignaTrackImpression]',
})
export class TrackImpressionDirective {
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _util: TrackUtil,
    private _injector: Injector,
  ) {}

  @Input('cignaTrackImpression')
  params: string | [string, ...unknown[]];

  @ContentChildren(TrackImpressionProductDirective, { descendants: true })
  set products(products: QueryList<TrackImpressionProductDirective>) {
    /**
     * Handle product params from DOM elements, which may change
     * without triggering change detection.
     * i.e.:
     * ```
     *    <span
     *      *ngSwitchDefault
     *      #impressionElement
     *      [cignaTrackImpressionProduct]="['myImpression', { text: impressionElement.innerText }]"
     *                                                              ^^^^^^^^^^^^^^^^^^^^^^^^^^^
     *    >{{ 'content.key' | translate }}</span>
     * ```
     */
    this._changeDetectorRef.detectChanges();

    const [eventName, ...extraParams] = Array.isArray(this.params)
      ? this.params
      : [this.params];
    const newProducts = products.filter(
      (product) =>
        !this._previousProducts.includes(product) &&
        product.params[0] === eventName,
    );
    this._previousProducts = [...this._previousProducts, ...newProducts];
    const productParams = newProducts.map((product) => product.params[1]);

    if (!productParams.length) {
      return;
    }

    this._util[TRACK_FN]<TrackEvent>({ injector: this._injector }, [
      eventName,
      productParams,
      ...extraParams,
    ]);
  }

  private _previousProducts: TrackImpressionProductDirective[] = [];
}
